import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/Bg-ios-dubai.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>
                Modernize Operations & Engage Users with Top iPhone App
                Developers in Dubai
              </h2>
            </div>
            <p>
              Are you looking to uplift your business with leading-edge iPhone
              apps? Your search ends here! TekRevol stands as a premier iOS app
              development company in Dubai, confident to transform your business
              endeavors. Our capable team of iPhone app developers is primed to
              take your business to new heights. We boast experienced team of
              professionals devoted to meeting your exclusive business needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Free Consultation!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
